/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/PaymentMethods',[
    'jquery',
    'lodash',
    'global/all'
], function ($, _, Roc) {
    'use strict';

    var addressType;
    var viewModel = {};
    var cfg = window.RocConfig;

    // TODO: replace this with mapping to PaymentMethods.Forms.js
    var forms = {
        paymentMethod: {
            Fields: [
               {
                   "Name": 'Method Id',
                   "Field": '#hdEditId',
                   "Param": 'id',
                   "Type": 'Hidden',
                   "Optional": true,
                   "ExcluedIfEmpty": true
               },
               {
                   "Name": 'Address Id',
                   "Field": '#hdAddressId',
                   "Param": 'addressId',
                   "Type": 'Hidden',
                   "Optional": true,
                   "ExcluedIfEmpty": true,
                   "GetValueMethod": {
                       fn: getSelectedBillingAddressId
                   }
               },
               {
                   "Name": 'Is Default',
                   "Field": '#hdMethodIsDefault',
                   "Param": 'isDefault',
                   "Type": 'Hidden',
                   "ExcludeFromErrorSummary": true
               },
               {
                   "Name": 'Last4',
                   "Field": '#hdLast4',
                   "Param": 'last4',
                   "Type": 'Hidden',
                   "GetValueMethod": {
                       fn: Roc.CreditCard.getLast4,
                       "Param": '#billing-card-number'
                   },
                   "ExcludeFromErrorSummary": true
               },
               {
                   "Name": 'Card Number',
                   "Field": '#billing-card-number',
                   "Param": 'cardNumber',
                   "Type": 'Text',
                   "ErrorMsg": '"Card Number" is not valid or this card type is not supported',
                   "Validators": [
                    {
                        "Type": 'Custom',
                        fn: isSupportedCreditCardType
                    }
                   ]
               },
               {
                   "Name": 'Expiration Month',
                   "Field": '#billing-expiration-month',
                   "Param": 'expMonth',
                   "Type": 'Select',
                   "Validators": [{
                       "Type": 'Integer'
                   }, {
                       "Type": 'MinValue',
                       "Value": 1
                   }, {
                       "Type": 'MaxValue',
                       "Value": 12
                   }, {
                       "Type": 'Custom',
                       fn: isValidExpirationMonth
                   }
                   ]
               },
               {
                   "Name": 'Expiration Year',
                   "Field": '#billing-expiration-year',
                   "Param": 'expYear',
                   "Type": 'Select'
               },
               {
                   "Name": 'Security Code',
                   "Field": '#billing-security-code',
                   "Param": 'securityCode',
                   "Type": 'Text',
                   "Validators": [
                      {
                          "Type": 'Integer'
                      },
                      {
                          "Type": 'CVV',
                          "CardNumField": '#billing-card-number'
                      }
                   ]
               }
            ],
            Validate: true
        },

        editPaymentMethod: {
            Fields: [
               {
                   "Name": 'Method Id',
                   "Field": '#hdEditId',
                   "Param": 'id',
                   "Type": 'Hidden'
               },
               {
                   "Name": 'Address Id',
                   "Field": '#hdAddressId',
                   "Param": 'addressId',
                   "Type": 'Hidden',
                   "Optional": true,
                   "ExcluedIfEmpty": true,
                   "GetValueMethod": {
                       fn: getSelectedBillingAddressId
                   },
                   "ErrorMsg": 'Please select billing address or add a new one'
               }
            ],
            Validate: true
        },

        billingAddress: {
            Fields: [
               {
                   "Name": 'Address Id',
                   "Field": '#hdAddressId',
                   "Param": 'address.id',
                   "Type": 'Hidden',
                   "Optional": true,
                   "ExcluedIfEmpty": true,
                   "GetValueMethod": {
                       fn: getSelectedBillingAddressId
                   }
               },
               {
                   "Name": 'First Name',
                   "Field": '#billing-first-name',
                   "Param": 'address.firstName',
                   "Type": 'Text'
               },
               {
                   "Name": 'Last Name',
                   "Field": '#billing-last-name',
                   "Param": 'address.lastName',
                   "Type": 'Text'
               },
               {
                   "Name": 'Company',
                   "Field": '#billing-company',
                   "Param": 'address.company',
                   "Type": 'Text',
                   "Optional": true
               },
               {
                   "Name": 'Address 1',
                   "Field": '#billing-address1',
                   "Param": 'address.address1',
                   "Type": 'Text'
               },
               {
                   "Name": 'Address 2',
                   "Field": '#billing-address2',
                   "Param": 'address.address2',
                   "Type": 'Text',
                   "Optional": true
               },
                {
                    "Name": 'Address 3',
                    "Field": '#billing-address3',
                    "Param": 'address.address3',
                    "Type": 'Text',
                    "Optional": true
                },
               {
                   "Name": 'City',
                   "Field": '#billing-city',
                   "Param": 'address.city',
                   "Type": 'Text'
               },
               {
                   "Name": 'State',
                   "Field": '#billing-state',
                   "Param": 'address.state',
                   "Type": 'Select'
               },
               {
                   "Name": 'Region',
                   "Field": '#billing-region',
                   "Param": 'address.region',
                   "Type": 'Text',
                   "Optional": true
               },
               {
                   "Name": 'Country',
                   "Field": '#billing-country',
                   "Param": 'address.country',
                   "Type": 'Select'
               },
               {
                   "Name": 'Zip/Postal Code',
                   "Field": '#billing-zip',
                   "Param": 'address.zip',
                   "Type": 'Text',
                   'Optional': true,
                   "Validators": [
                            {
                                'Type': 'RequiredIfField',
                                'ConditionalField': '#billing-country',
                                'ConditionalFieldAttr': 'data-isPostalCodeRequired',
                                'ConditionalValue': 'true',
                                'ConditionalFieldType': 'Select'
                            },
                          {
                              "Type": 'Zip',
                              "ReferencedField": '#billing-country',
                              'ReferencedFieldAttr': 'data-isPostalCodeRequired',
                              'ReferencedValue': 'true',
                              'ReferencedFieldType': 'Select'
                          }
                   ]
               },
               {
                   "Name": 'Phone',
                   "Field": '#billing-phone',
                   "Param": 'address.phone',
                   "Type": 'Text'
               },
               {
                   "Name": 'Is Default',
                   "Field": '#billing-hdAddressIsDefault',
                   "Param": 'address.isDefault',
                   "Type": 'Hidden',
                   "DefaultValue": 'false'
               },
                {
                    "Name": 'Is Organization Address',
                    "Field": '#shipping-is-organization-address',
                    "Param": 'address.isOrganizationAddress',
                    "Type": 'Checkbox',
                    "Optional": true
                }
            ],
            Validate: true
        },
        selectedBillingAddress: {
            Fields: [{
                "Name": 'Billing address Id',
                "Field": '#hdAddressId',
                "Param": 'creditCardData.addressId',
                "Type": 'Hidden',
                "GetValueMethod": { fn: getSelectedBillingAddressId }
            }],
            Validate: true,
            RequestParam: 'billingAddressId',
            RequestParamType: 'SingleValue',
            ErrorMsg: 'Please select billing address or create a new one.'
        }
    }

    function isSupportedCreditCardType(ccNum) {
        if (Roc.CreditCard.validateCCNum(ccNum)) {
            var ccType = Roc.CreditCard.detectCreditCardType(ccNum);
            if (ccType !== null) {
                var cc = _.find(viewModel.supportedCreditCardTypes, { code: ccType });
                if (cc !== null) {
                    return true;
                }
            }
        }
        return false;
    }

    function isValidExpirationMonth(month) {
        var expirationYearDefinition = _.find(forms.paymentMethod.Fields, function (f) { return f.Param === 'expYear'; });
        if (expirationYearDefinition !== null) {
            return Roc.CreditCard.validateExpirationDate(month, $(expirationYearDefinition.Field).val());
        }
        return true;
    }

    function getSelectedBillingAddressId() {
        return Roc.UI.getItemId('.' + viewModel.address.btns.btnSelected.cssClass);
    };

    function unSelectBillingAddress() {
        Roc.UI.swapButtons(viewModel.address.btns, null);
    }

    /* Helpers UI */

    function checkEmptyResultsDisplay() {
        Roc.UI.checkEmptyResultsDisplay(viewModel);
    }

    function removeFromUi(editId) {
        Roc.UI.removeItemFromUi(editId, viewModel);
    };

    function closeForm() {
        Roc.UI.closeForm(viewModel.formSelector);
    }

    function openForm() {
        Roc.UI.openForm(viewModel.formSelector);
    }

    function updateCreditCardIcons() {
        var paymentIcons = '.payment-type-selection .payment-icon';
        $(paymentIcons).removeClass('active');
        var ccType = Roc.CreditCard.detectCreditCardType($('#billing-card-number').val());
        var iconCssClass = Roc.CreditCard.getCreditCardCssClass(ccType);
        if (iconCssClass !== '') {
            $(paymentIcons + '.' + iconCssClass).addClass('active');
        }
    };

    /* ViewModel related */

    function getPaymentMethodViewModel(method) {
        method.enableRemove = viewModel.enableRemove;
        method.cardName = Roc.CreditCard.getCreditCardName(method.cardType);
        method.cardCssClass = Roc.CreditCard.getCreditCardCssClass(method.cardType);
        method.btnUseThis = viewModel.btns.btnUseThis;
        method.btnSelected = viewModel.btns.btnSelected;
        return method;
    };

    function getAddressViewModel(addr) {
        addr.btnUseThis = viewModel.address.btns.btnUseThis;
        addr.btnSelected = viewModel.address.btns.btnSelected;
        return addr;
    };

    function updateMethod(method, editId) {
        var methodViewModel = getPaymentMethodViewModel(method);
        if (typeof editId !== 'undefined' && editId !== '') {
            $.each(viewModel.pmList, function (i, v) {
                if (v.id === editId) {
                    viewModel.pmList[i] = methodViewModel;
                    return;
                }
            });

            Roc.UI.template(viewModel.pmTmpSelector, methodViewModel).then(function (renderedTemplate) {
                $(viewModel.listSelector + ' .item[data-id=' + editId + ']').replaceWith(renderedTemplate);
            });
        } else {
            viewModel.pmList.push(methodViewModel);

            Roc.UI.template(viewModel.pmTmpSelector, methodViewModel).then(function (renderedTemplate) {
                $(viewModel.listSelector).append(renderedTemplate);
                checkEmptyResultsDisplay();
            });
        }

        // Update & add address entity
        var newAddress = true;
        var addressViewModel = getAddressViewModel(method.address);
        $.each(viewModel.addressList, function (i, a) {
            if (a.id === method.addressId) {
                viewModel.addressList[i] = addressViewModel;
                newAddress = false;
                return;
            }
        });
        if (newAddress) {
            viewModel.addressList.push(addressViewModel);
        }
    };

    /* Events */

    function setDefaultEvt() {
        $(document).on('click', '.setDefault', function () {
            if ($(this).hasClass('default')) {
                return;
            }

            var btnSetDef = this;
            var id = Roc.UI.getItemId(this);
            $.ajax({
                url: viewModel.apiUrl + '/api/payment/set-default/' + id,
                type: 'POST',
                dataType: 'json',
                complete: function (xhr) {
                    Roc.Logger.info('PaymentMethods -> setDefaultEvt');
                    Roc.Logger.info(xhr);
                    if (xhr.status === 200) {
                        Roc.UI.swapButtons(viewModel.btns, btnSetDef);
                    }
                }
            });
        });
    };

    function setEditId(id) {
        $(viewModel.formPannelSelector).attr('data-editId', id);
    }

    function clearEditId() {
        $(viewModel.formPannelSelector).removeAttr('data-editId');
    }

    function getEditId() {
        return $(viewModel.formPannelSelector).attr('data-editId');
    }

    function editMethodEvt(callback) {
        $(document).on('click', '.editMethod', function () {
            var id = Roc.UI.getItemId(this);
            setEditId(id);
            $(viewModel.formPannelSelector + ' .panel-title .action').text('Update');
            Roc.Forms.loadDetails(id, forms.paymentMethod, viewModel.pmList);
            Roc.Forms.loadDetails(id, forms.billingAddress, viewModel.pmList);
            openForm();

            if (typeof (callback) === 'function') {
                callback(id);
            }
        });
    };

    function removeMethodEvt() {
        $(document).on('click', '.removeMethod', function () {
            var id = Roc.UI.getItemId(this);
            Roc.UI.confirm('Are you sure you want to delete this item?', function () {
                $.ajax({
                    url: viewModel.apiUrl + '/api/payment/' + id,
                    type: 'DELETE',
                    dataType: 'json',
                    contentType: 'application/json',
                    complete: function (xhr) {
                        Roc.Logger.info('PaymentMethods -> removeMethodEvt');
                        Roc.Logger.info(xhr);
                        if (xhr.status === 200 || xhr.status === 204) {
                            closeForm();
                            removeFromUi(id);
                        }
                    }
                });
            });
        });
    };

    function submitFormEvt(callback) {
        var paymentSubmitButton = '#submitPaymentMethodForm';

        $(document).on('click', paymentSubmitButton, function () {
            var methodId = getEditId();
            var requestType = methodId ? 'PUT' : 'POST';
            var paymentForm = methodId ? forms.editPaymentMethod : forms.paymentMethod;
            var dataPayment = Roc.Forms.getFormValues(paymentForm);
            var dataBiling = Roc.Forms.getFormValues(forms.billingAddress);
            var paymentMethodFormValid = Roc.Validation.validateForm(paymentForm);

            Roc.Core.lockButton(paymentSubmitButton);

            function releaseLockedButton() {
                Roc.Core.releaseLockedButton(paymentSubmitButton);
            };

            if (viewModel.newAddressFormActive()) {
                delete dataPayment.addressId;
                var billingAddressValid = Roc.Validation.validateForm(forms.billingAddress);
                if (!paymentMethodFormValid || !billingAddressValid) {
                    releaseLockedButton();
                    return;
                }
            } else {
                if (!paymentMethodFormValid) {
                    releaseLockedButton();
                    return;
                }

                if (!dataPayment.addressId) {
                    Roc.UI.displayErrorPopup('Please select billing address or create a new one.');
                    releaseLockedButton();
                    return;
                }
            }

            dataPayment.address = dataBiling;

            $.ajax({
                url: viewModel.apiUrl + '/api/payment/',
                data: JSON.stringify(dataPayment),
                type: requestType,
                dataType: 'json',
                contentType: 'application/json',
                complete: function (xhr) {
                    Roc.Logger.info('PaymentMethods -> submitFormEvt');
                    Roc.Logger.info(xhr);
                    var response = xhr.responseJSON || {};

                    if (xhr.status === 200 || xhr.status === 201) {
                        closeForm();
                        updateMethod(response, methodId);

                        if (typeof (callback) === 'function') {
                            callback(response);
                        }
                    } else {
                        Roc.UI.displayErrorPopup(xhr.responseJSON.message);
                    };

                    releaseLockedButton();
                }
            });
        });
    };

    function showAddNewMethodScreen() {
        delete viewModel.editMethodId;

        Roc.UI.renderFormTemplate(viewModel.pmFormTmpSelector, viewModel, $(viewModel.formSelector)).then(function () {
            Roc.UI.bindAddressAutoCompleteEvt(addressType);
        });
    }

    function showEditMethodScreen(methodId) {
        $.each(viewModel.pmList, function (i, v) {
            if (v.id === methodId) {
                viewModel.method = v;
                return;
            }
        });

        viewModel.editMethodId = methodId;

        Roc.UI.renderFormTemplate(viewModel.pmFormTmpSelector, viewModel, $(viewModel.formSelector)).then(function () {
            Roc.UI.bindAddressAutoCompleteEvt(addressType);
            //Update btn to selected + append first after add new
            var selectedAddressSel = '#selectAddressWrapper [data-id=' + viewModel.method.addressId + ']';
            Roc.UI.swapButtons(viewModel.address.btns, selectedAddressSel + ' .' + viewModel.address.btns.btnUseThis.cssClass);
            $("#selectAddressWrapper .item:first").after($(selectedAddressSel));
            viewModel.method = null;
        });


    }

    function closeFormEvt(callback) {
        Roc.UI.onCloseFormEvt(viewModel.formSelector, function () {
            clearEditId();
            $(viewModel.formSelector).empty();
            $('.panel-title .action').text('Add');
            if (typeof (callback) === 'function') {
                callback();
            }
        });
    }

    function openFormEvt(callback) {
        Roc.UI.onOpenFormEvt(viewModel.formSelector, function () {
            var editId = getEditId();
            if (!editId) {
                showAddNewMethodScreen();
                updateCreditCardIcons();
            } else {
                showEditMethodScreen(editId);
            }

            Roc.UI.updateRegionStateDisplay(addressType);
            if (typeof (callback) === 'function') {
                callback();
            }
        });
    }

    function cancelFormEvt() {
        $(document).on('click', '#cancelPaymentMethodForm', function () {
            closeForm();
        });
    };

    function creditNumChangeEvt() {
        $(document).on('keyup keypress blur change', '#billing-card-number', function () {
            updateCreditCardIcons();
        });
    };

    function addNewAddressEvt() {
        $(document).on('click', '#billing-addNewAddress', function () {
            $('#newAddressFormWrapper').show();
            unSelectBillingAddress();
            $(this).hide();
            $('#selectAddressWrapper').hide();
            Roc.EventManager.notify(Roc.Events.address.OPEN_BILLING_FORM);
        });
    }

    function useAddressEvt() {
        Roc.UI.btnUseThisClickEvt(viewModel.address.btns, function (addressId) {
        });
    }

    function copyBillingFromShipping(shippingForm) {
        try {
            _.forEach(shippingForm.Fields, function (f) {
                var destField = _.find(forms.billingAddress.Fields, { Param: 'address.' + f.Param });
                if (destField) {
                    if (f.Param === 'country' || f.Param === 'state') {
                        var $field = $(f.Field);
                        // check if field exists and is visible
                        // "State" field may be hidden (it depends on selected country)
                        if ($field.length === 0 || !$field.is(':visible')) {
                            return;
                        }
                        var selected = $field.find(':selected');
                        var enableBilling = selected.attr('data-enablebilling');
                        if (enableBilling === null || typeof enableBilling === 'undefined' || enableBilling === '' || enableBilling.toLowerCase() === 'false') {
                            throw "Unfortunately, we do not allow billing address from: " + $field.find(':selected').text() + ".  Please enter a new address for your billing address";
                        }
                    }
                    $(destField.Field).val($(f.Field).val()).prop('disabled', true).trigger(Roc.Events.general.CHANGE);
                }
            });
        } catch (e) {
            Roc.UI.displayErrorPopup(e);
            clearBillingForm();
        }

        Roc.UI.updateRegionStateDisplay(addressType);
    }

    function copyBillingFromAddressBook(addressBookEntry) {
        for (var p in addressBookEntry) {
            if (addressBookEntry.hasOwnProperty(p)) {
                var destField = _.find(forms.billingAddress.Fields, { Param: 'address.' + p });
                if (destField && p !== 'id') {
                    $(destField.Field).val(addressBookEntry[p]);
                    $(destField.Field).prop('disabled', true);
                }
            }
        }
        Roc.UI.updateRegionStateDisplay(addressType);
    }

    function clearBillingForm() {
        Roc.Forms.clearData(forms.billingAddress, true);
        Roc.UI.updateRegionStateDisplay(addressType);
    }

    /* Init */

    function baseInit(model) {
        addressType = 'billing';
        viewModel = {
            apiUrl: model.apiUrl,
            countries: model.countries || {},
            defaultCountryCode : cfg.defaultCountryCode,
            states: model.states || {},
            expirationMonths: model.expirationMonths || {},
            expirationYears: model.expirationYears || {},
            pmList: model.paymentMethods || {},
            addressList: model.addresses || {},
            addressType: addressType,
            formSelector: '#' + addressType + '-address-form',
            formPannelSelector: '#' + addressType + '-form-panel',
            listSelector: '.roc-list-payments .interiorList',
            pmTmpSelector: '#paymentMethod-Tmp',
            pmFormTmpSelector: '#paymentMethodForm-Tmp',
            emptyResultsSelector: '#noEntryMsg',            
            paymentMethodFormActionButtons: '[data-roc-field="PaymentMethodFormActionButtons"]',
            supportedCreditCardTypes: model.supportedCreditCards,
            canAddOrganizationAddresses: model.canAddOrganizationAddresses,
            canEditOrganizationAddresses: model.canEditOrganizationAddresses,

            btns: {
                btnUseThis: { cssClass: 'setDefault', text: 'Set as default method' },
                btnSelected: { cssClass: 'default', text: 'Default payment method' }
            }
        };

        viewModel.address = {
            btns: {
                btnUseThis: { cssClass: 'useThisBillingAddress', text: 'Use this address' },
                btnSelected: { cssClass: 'selected', text: 'Selected address' }
            }
        };

        viewModel.newAddressFormActive = function () {
            return $('.formWrapper.' + addressType).is(':visible');
        }
    }

    function loadViewModelDetails() {
        viewModel.addressList = _.filter(viewModel.addressList, 'enableBilling');
        viewModel.states = _.filter(viewModel.states, 'enableBilling');

        $.each(viewModel.addressList, function (i, addr) {
            getAddressViewModel(addr);
        });

        $.each(viewModel.pmList, function (i, method) {
            getPaymentMethodViewModel(method);
        });
    }

    function bindEvents(callbacks) {
        var cbs = callbacks;
        creditNumChangeEvt();
        addNewAddressEvt();
        editMethodEvt((cbs && cbs.editMethodCallback) ? cbs.editMethodCallback : null);
        useAddressEvt();
        Roc.UI.bindAddressFormEvents(addressType);

        openFormEvt((cbs && cbs.openFormCallback) ? cbs.openFormCallback : null);
        closeFormEvt((cbs && cbs.closeFormCallback) ? cbs.closeFormCallback : null);
        submitFormEvt((cbs && cbs.submitFormCallback) ? cbs.submitFormCallback : null);
        cancelFormEvt();
    }

    function bindMyAccountEvents() {
        bindEvents({
            openFormCallback: function () {
                Roc.UI.scrollTo(viewModel.formPannelSelector, -60);
            },

            closeFormCallback: function () {
                Roc.UI.scrollTo('body', 0);
            },

            submitFormCallback: function (dataPayment) {

            }
        });

        setDefaultEvt();
        removeMethodEvt();
    };

    function initMyAccount(model) {
        baseInit(model);
        viewModel.enableRemove = true;
        loadViewModelDetails();

        Roc.UI.template('userPaymentMethods-Tmp', viewModel).then(function (renderedTemplate) {
            $('#paymentMethodsWrapper').html(renderedTemplate);
            bindMyAccountEvents();
        });
    }

    function bindCheckoutEvents(callbacks) {
        bindEvents(callbacks);
    }

    function initCheckout(model) {
        baseInit(model);
        viewModel.btns = {
            btnUseThis: { cssClass: 'useThisPaymentMethod', text: 'Use this method' },
            btnSelected: { cssClass: 'selectedPaymentMethod', text: 'Selected method' }
        };
        loadViewModelDetails();
        viewModel.forms = forms;
        return viewModel;
    }

    var PaymentMethods = {
        initCheckout: initCheckout,
        bindCheckoutEvents: bindCheckoutEvents,
        initMyAccount: initMyAccount,
        getEditId: getEditId,
        isSupportedCreditCardType: isSupportedCreditCardType,
        getSelectedBillingAddressId: getSelectedBillingAddressId,
        copyBillingFromAddressBook: copyBillingFromAddressBook,
        copyBillingFromShipping: copyBillingFromShipping,
        clearBillingForm: clearBillingForm
    };

    Roc.Logger.debug('PaymentMethods.js Loaded:', PaymentMethods);

    return PaymentMethods;
});

